import { throttle } from 'redux-saga'
import { put } from 'redux-saga/effects'
import { updateMapLocationAction } from 'actions/mapActions'
import { THROTTLE_UPDATE_MAP_LOCATION } from 'actions/mapTypes'

function* updateMapLocation() {
  yield put(updateMapLocationAction())
}

export function* watchThrottleUpdateMapLocation() {
  yield throttle(300, THROTTLE_UPDATE_MAP_LOCATION, updateMapLocation)
}



// WEBPACK FOOTER //
// ./src/sagas/throttleUpdateMapLocationSaga.js